import { z } from 'zod';

export const userStatusSchema = z.enum(['active', 'suspended', 'deactivated']);

export const roleNameSchema = z.enum(['admin', 'manager', 'operator', 'monitor']);

export type UserStatus = 'active' | 'suspended' | 'deactivated';
export type RoleName = 'admin' | 'manager' | 'operator' | 'monitor';

export interface AdminUser {
  email: string;
  display_name: string | null;
  phone: string | null;
  role: string | null;
  organizations: string[];
  status: UserStatus;
  created_at: string;
}

export interface AdminUsersResponse {
  users: AdminUser[];
  total: number;
  page: number;
  limit: number;
}

export interface AdminUserStats {
  total: number;
  active: number;
  suspended: number;
  deactivated: number;
}

export const adminUserSchema: z.ZodType<AdminUser> = z.object({
  email: z.email(),
  display_name: z.string().nullable(),
  phone: z.string().nullable(),
  role: z
    .string()
    .nullish()
    .transform((v) => v ?? null),
  organizations: z
    .array(z.string())
    .nullish()
    .transform((v) => v ?? []),
  status: userStatusSchema,
  created_at: z.string(),
});

export const adminUsersResponseSchema: z.ZodType<AdminUsersResponse> = z.object({
  users: z.array(adminUserSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export const adminUserStatsSchema: z.ZodType<AdminUserStats> = z.object({
  total: z.number(),
  active: z.number(),
  suspended: z.number(),
  deactivated: z.number(),
});

export interface AuditLog {
  action: string;
  user_mail: string | null;
  user_agent: string | null;
  details: {
    status: number | null;
    duration_ms: number | null;
  } | null;
  created_at: string;
}

export interface AuditLogsResponse {
  logs: AuditLog[];
  total: number;
  page: number;
  limit: number;
}

export const auditLogsResponseSchema: z.ZodType<AuditLogsResponse> = z.object({
  logs: z.array(
    z.object({
      action: z.string(),
      user_mail: z.string().nullable(),
      user_agent: z.string().nullable(),
      details: z
        .object({
          status: z.number().nullable(),
          duration_ms: z.number().nullable(),
        })
        .nullable(),
      created_at: z.string(),
    }),
  ),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
